import { PRODUCT_BULK_SELECTION_LIMIT } from '../constants/selection';

export const canAddEntities = (selection, entriesToAdd) => {
  const existingKeys = new Set(selection.keys);
  const newCount = entriesToAdd.filter((entry) => !existingKeys.has(entry.key)).length;
  if (newCount === 0) {
    return { ok: true };
  }

  if (selection.keys.length + newCount > PRODUCT_BULK_SELECTION_LIMIT) {
    return { ok: false, reason: 'limit' };
  }

  return { ok: true };
};
